import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './ToggleTab.scss';

const ToggleTabs = ({theme, children, ...props}) => (
  <div className={`toggle-tabs toggle-tabs--${theme}`} {...props}>
    {children}
  </div>
);

export const Tab = ({children, onClick, active, ...props}) => (
  <div
    className={classnames({'toggle-tabs__tab': true, 'toggle-tabs__tab-active': active})}
    onClick={onClick}
    {...props}
  >
    {children}
    {active && <span className="point-out" />}
  </div>
);

Tab.protoTypes = {
  imageComponent: PropTypes.elementType,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ToggleTabs;
